import React from "react";
import { Navigate, Outlet } from "react-router-dom";
import authService from "../routes/authService";

const ProtectedRoute = () => {
  const token = authService.getToken();

  if (!token || !String(token).trim()) {
    return <Navigate to="/login" replace />;
  }

  // Se o token existe, permite o acesso à rota aninhada
  return <Outlet />;
};

export default ProtectedRoute;
